/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './animation035.less';

interface IAnimation035Item {
  text: string;
  icon: string;
}

interface IAnimation035Props {
  items: IAnimation035Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation035: React.FunctionComponent<IAnimation035Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1500);
    } else {
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag) {
      startPlay();
    }
  }, [playFlag]);

  return (
    <div ref={crrRef} className={`animation035 component ${className || ''}`}>
      {items.map((itm: IAnimation035Item, idx: number) => (
        <div key={idx} className="animation035-contaner">
          <div
            className={`animation035-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              src={require(`../../../../../assets/${itm.icon}.jpg`).default}
              alt=""
            />
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Animation035;
